<template>
  <v-app-bar
    app
    flat
    height="64"
  >
    <v-row>
      <v-col class="flex-grow">
        <v-row class="d-flex flex-nowrap">
          <v-col
            md="auto"
          >
            <search-bar
              v-if="showSearchBar"
              ref="searchBar"
              class="client-search"
              menu-class="header-bar-search"
            />
          </v-col>

          <v-col
            v-if="showDataFreshness && dataFreshnessIndicators"
            md="auto"
          >
            <v-dialog
              v-model="toggleDataFreshnessLegend"
              hide-overlay
              max-width="600"
            >
              <template v-slot:activator="{ on }">
                <v-row
                  class="cursor-pointer pt-3 align-center caption flex-nowrap"
                  v-on="on"
                >
                  <v-col class="col-1 px-0 data-refresh-icon">
                    <v-icon
                      class="mr-1"
                      :color="dataFreshnessIndicators.color"
                      small
                    >
                      {{ dataFreshnessIndicators.icon }}
                    </v-icon>
                  </v-col>

                  <v-col
                    v-if="$vuetify.breakpoint.width > 850"
                    class="col-10 ml-2"
                  >
                    <v-row
                      :class="`
                        font-weight-${dataFreshnessIndicators.subtext ? 'bold' : 'medium'}
                        ${dataFreshnessIndicators.subtext ? '' : 'line-height-double'}
                      `"
                    >
                      <v-col class="pa-0 text-capitalize text-truncate data-refresh-text">
                        {{ dataFreshnessIndicators.text }}
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="dataFreshnessIndicators.subtext"
                      class="mt-1 text-capitalize"
                    >
                      <v-col class="pa-0 text-truncate data-refresh-text">
                        {{ dataFreshnessIndicators.subtext }}

                        <span class="font-weight-medium">
                          {{ dataFreshnessIndicators.datetime }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </template>

              <v-card>
                <v-card-title class="title px-9 py-6">
                  <v-row>
                    <v-col
                      class="flex-grow py-0 darkestblue--text"
                    >
                      Data Status
                    </v-col>

                    <v-spacer />

                    <v-col
                      class="flex-shrink-1 col-2 py-0 text-right"
                    >
                      <v-btn
                        :ripple="false"
                        icon
                        @click.stop="hideLegendDataFreshness"
                      >
                        <v-icon color="brightblue">
                          close
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-divider />

                <v-card-text class="px-6 pb-6">
                  <v-row
                    class="mt-1 text-capitalize"
                  >
                    <v-col class="ma-6">
                      <v-row>
                        <v-col>
                          <v-row class="pr-1 font-weight-bold">
                            Status
                          </v-row>

                          <v-row class="mt-2 font-weight-medium">
                            {{ dataFreshnessIndicators.text }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row
                        v-if="dataFreshnessIndicators.subtext"
                        class="pt-3"
                      >
                        <v-col>
                          <v-row class="pr-1 font-weight-bold">
                            {{ dataFreshnessIndicators.subtext }}
                          </v-row>

                          <v-row class="mt-2 font-weight-medium">
                            {{ dataFreshnessIndicators.datetime }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row
                        v-if="dataFreshnessIndicators.subtext && dataFreshnessIndicators.datetime"
                        class="pt-3"
                      >
                        <v-col>
                          <v-row class="pr-1 font-weight-bold">
                            Timezone
                          </v-row>

                          <v-row class="mt-2 font-weight-medium">
                            Local Time
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        class="d-flex"
        md="auto"
      >
        <v-row class="d-flex flex-nowrap justify-end justify-xl-end justify-lg-end justify-md-end justify-sm-end justify-xs-center align-center pt-1">
          <v-col
            v-if="showLegendBar"
            class="header-action col-1 pl-sm-0 text-right text-sm-end  text-xs-center"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-btn
                  color="coolgray"
                  icon
                  small
                  v-bind="tooltipAttrs"
                  v-on="tooltipOn"
                  @click="toggleLegend"
                >
                  <font-awesome-icon
                    :icon="['fas', 'map']"
                    size="xl"
                  />
                </v-btn>
              </template>

              <span>Legend</span>
            </v-tooltip>

            <legend-bar />
          </v-col>

          <v-col
            class="header-action col-1 pl-sm-0 text-right text-sm-end  text-xs-center"
          >
            <v-menu
              v-model="openHelpMenu"
              :close-on-content-click="false"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="coolgray"
                  icon
                  small
                  title="Help"
                  v-bind="attrs"
                  v-on="on"
                >
                  <font-awesome-icon
                    :icon="['fas', 'circle-question']"
                    size="xl"
                  />
                </v-btn>
              </template>

              <v-list
                dense
                class="py-0 help-menu-list"
              >
                <div
                  v-for="(section, sectionIndex) in helpMenuSections"
                  :key="section.id"
                >
                  <v-subheader class="caption text-uppercase">
                    {{ section.title }}
                  </v-subheader>

                  <!-- Standard menu items -->
                  <template v-if="section.id !== 'about'">
                    <v-list-item
                      v-for="item in section.items"
                      :key="item.id"
                      :class="[
                        'help-menu-item',
                        {
                          'help-menu-item--tour': item.id === 'start-tour' || item.id === 'resume-tour',
                        },
                      ]"
                      :disabled="item.disabled"
                      @click="handleHelpItemClick(item)"
                    >
                      <v-list-item-icon class="mr-3">
                        <font-awesome-icon
                          :icon="item.icon"
                          size="sm"
                        />
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <!-- About section - read-only info display -->
                  <template v-if="section.id === 'about'">
                    <v-list-item
                      v-for="item in section.items"
                      :key="item.id"
                      :disabled="item.disabled"
                      @click="handleHelpItemClick(item)"
                    >
                      <v-list-item-icon class="mr-3">
                        <font-awesome-icon
                          :icon="item.icon"
                          size="sm"
                        />
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-divider v-if="sectionIndex < helpMenuSections.length - 1" />
                </div>
              </v-list>
            </v-menu>

            <v-dialog
              v-model="openFeedbackDialog"
              max-width="720"
            >
              <v-card>
                <v-card-title class="title px-6 py-4">
                  <v-row>
                    <v-col class="flex-grow py-0 darkestblue--text">
                      Send Feedback
                    </v-col>

                    <v-spacer />

                    <v-col class="flex-shrink-1 col-2 py-0 text-right">
                      <v-btn
                        :ripple="false"
                        icon
                        @click.stop="openFeedbackDialog = false"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'times']"
                          size="lg"
                        />
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-divider />

                <v-card-text class="px-6 pt-4 pb-2">
                  <v-form
                    ref="feedbackFormRef"
                    @submit.prevent="submitFeedback"
                  >
                    <v-select
                      v-model="feedbackForm.category"
                      :items="feedbackCategories"
                      item-text="text"
                      item-value="value"
                      outlined
                      dense
                      label="Category"
                    >
                      <template v-slot:prepend-inner>
                        <font-awesome-icon
                          :icon="['fas', 'list']"
                          class="mt-1"
                        />
                      </template>
                    </v-select>

                    <v-text-field
                      v-model="feedbackForm.summary"
                      outlined
                      dense
                      maxlength="140"
                      counter="140"
                      label="Summary"
                      placeholder="Briefly describe your feedback"
                    >
                      <template v-slot:prepend-inner>
                        <font-awesome-icon
                          :icon="['fas', 'comment-dots']"
                          class="mt-1"
                        />
                      </template>
                    </v-text-field>

                    <v-textarea
                      v-model="feedbackForm.details"
                      outlined
                      auto-grow
                      rows="4"
                      maxlength="5000"
                      counter="5000"
                      label="Details"
                      placeholder="Share details that can help us reproduce or understand the issue."
                    />
                  </v-form>
                </v-card-text>

                <v-card-actions class="px-6 pb-5">
                  <v-spacer />
                  <v-btn
                    text
                    class="text-none"
                    :disabled="isSubmittingFeedback"
                    @click="openFeedbackDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="text-none"
                    :loading="isSubmittingFeedback"
                    :disabled="isSubmittingFeedback"
                    @click="submitFeedback"
                  >
                    Submit Feedback
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="openClearCacheDialog"
              max-width="560"
            >
              <v-card class="help-dialog help-dialog--cache">
                <v-card-title class="help-dialog__title-wrap px-6 py-4">
                  <div class="help-dialog__title-block">
                    <div class="help-dialog__title-row">
                      <font-awesome-icon
                        :icon="['fas', 'trash-can']"
                        class="help-dialog__title-icon"
                      />
                      <span class="help-dialog__title-text">Clear Cache & Data</span>
                    </div>
                    <p class="help-dialog__subtitle mb-0">
                      Reset local cache to force fresh app assets and data.
                    </p>
                  </div>

                  <v-btn
                    :ripple="false"
                    icon
                    class="help-dialog__close-btn"
                    :disabled="isClearingCache"
                    @click.stop="openClearCacheDialog = false"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'times']"
                      size="lg"
                    />
                  </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text class="px-6 pt-5 pb-2">
                  <div class="help-dialog__section mb-4">
                    <p class="help-dialog__section-label mb-2">
                      This action removes:
                    </p>

                    <div class="help-dialog__checklist">
                      <div class="help-dialog__checklist-item">
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="help-dialog__check-icon"
                        />
                        <span>Cached files and app bundles</span>
                      </div>
                      <div class="help-dialog__checklist-item">
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="help-dialog__check-icon"
                        />
                        <span>Local storage and session data</span>
                      </div>
                      <div class="help-dialog__checklist-item">
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="help-dialog__check-icon"
                        />
                        <span>Service worker cache</span>
                      </div>
                    </div>
                  </div>

                  <div class="help-dialog__note">
                    <font-awesome-icon
                      :icon="['fas', 'triangle-exclamation']"
                      class="help-dialog__note-icon"
                    />
                    <p class="mb-0">
                      The app reloads after cache clear. You may need to sign in again.
                    </p>
                  </div>
                </v-card-text>

                <v-card-actions class="px-6 pb-5">
                  <v-spacer />
                  <v-btn
                    outlined
                    class="text-none"
                    :disabled="isClearingCache"
                    @click="openClearCacheDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="warning"
                    class="text-none"
                    :loading="isClearingCache"
                    :disabled="isClearingCache"
                    @click="clearAppCache"
                  >
                    Clear Cache
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="openAboutDialog"
              max-width="560"
            >
              <v-card class="help-dialog help-dialog--about">
                <v-card-title class="help-dialog__title-wrap px-6 py-4">
                  <div class="help-dialog__title-block">
                    <div class="help-dialog__title-row">
                      <font-awesome-icon
                        :icon="['fas', 'circle-info']"
                        class="help-dialog__title-icon"
                      />
                      <span class="help-dialog__title-text">About iAdOps</span>
                    </div>
                    <p class="help-dialog__subtitle mb-0">
                      Quick environment details for support and troubleshooting.
                    </p>
                  </div>

                  <v-btn
                    :ripple="false"
                    icon
                    class="help-dialog__close-btn"
                    @click.stop="openAboutDialog = false"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'times']"
                      size="lg"
                    />
                  </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text class="px-6 pt-5 pb-2">
                  <div class="about-metadata">
                    <div class="about-metadata__row">
                      <div class="about-metadata__label">
                        Version
                      </div>
                      <div class="about-metadata__value about-metadata__value--mono">
                        {{ appVersion }}
                      </div>
                    </div>

                    <div class="about-metadata__row">
                      <div class="about-metadata__label">
                        Environment
                      </div>
                      <div class="about-metadata__value text-capitalize">
                        {{ appEnvironment }}
                      </div>
                    </div>

                    <div class="about-metadata__row">
                      <div class="about-metadata__label">
                        Current View
                      </div>
                      <div class="about-metadata__value">
                        {{ reportKey || 'N/A' }}
                      </div>
                    </div>
                  </div>
                </v-card-text>

                <v-card-actions class="px-6 pb-5">
                  <v-spacer />
                  <v-btn
                    text
                    class="text-none"
                    @click="openAboutDialog = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { fireanalytics } from 'src/store/firebase'
import api from 'src/store/api'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')
const {
  mapGetters: mapToolsGetters,
  mapState: mapToolsState,
} = createNamespacedHelpers('tools')

export default {
  name: 'Header',
  components: {
    LegendBar: () => import('src/delivery/components/modals/LegendBar'),
    SearchBar: () => import('src/tools/components/search/SearchBarFirestore'),
  },
  props: {
    canResumeTour: {
      type: Boolean,
      default: false,
    },
    pageHelpPath: {
      type: String,
      default: '/docs',
    },
  },
  data() {
    return {
      openHelpMenu: false,
      openAboutDialog: false,
      openFeedbackDialog: false,
      isSubmittingFeedback: false,
      openClearCacheDialog: false,
      isClearingCache: false,
      feedbackForm: {
        category: 'general',
        summary: '',
        details: '',
      },
    }
  },
  computed: {
    ...mapAuthGetters(['inDarkMode', 'inDemoMode', 'isInternalUser']),
    ...mapToolsGetters([
      'currentColumns',
      'currentGroups',
      'didLastRefreshFail',
      'indicateDataRefreshed',
      'indicateDataRefreshing',
      'isValidRoute',
      'isDataRefreshing',
      'reportKey',
      'storedItems',
    ]),
    ...mapLayoutGetters([
      'showDataFreshness',
      'showInfoBar',
      'showLegendBar',
      'showSearchBar',
    ]),
    ...mapToolsState({
      isLegendModalVisible: (state) => state.isLegendModalVisible,
      showDataFreshnessLegend: (state) => state.showDataFreshnessLegend,
    }),

    toggleDataFreshnessLegend: {
      get() {
        return this.showDataFreshnessLegend
      },
      set(value) {
        this.$store.commit('tools/showDataFreshnessLegend', value)
      },
    },

    appVersion() {
      return process.env.VUE_APP_VERSION || 'unknown'
    },

    appEnvironment() {
      return process.env.VUE_APP_ENV || process.env.NODE_ENV || 'unknown'
    },

    /**
     * Gets the view data for the data freshness indicator
     *
     * @returns {Object} indicator { color, datetime, icon, subtext, text }
     */
    dataFreshnessIndicators() {
      const {
        indicateDataRefreshed,
        indicateDataRefreshing,
      } = this

      if (indicateDataRefreshing) return indicateDataRefreshing

      if (indicateDataRefreshed) return indicateDataRefreshed

      return false
    },

    feedbackCategories() {
      return [
        { text: 'General', value: 'general' },
        { text: 'Bug Report', value: 'bug' },
        { text: 'Feature Request', value: 'feature' },
        { text: 'Question', value: 'question' },
        { text: 'Other', value: 'other' },
      ]
    },

    showTourAction() {
      return !!this.isValidRoute
    },

    pageGuideSubtitle() {
      const reportName = this.$route?.params?.reportName || this.reportKey || ''
      const guideSubtitleByRoute = {
        admin: 'Open admin workflow steps and handoff references',
        discrepancy: 'Open discrepancy investigation and triage guidance',
        organization: 'Open client and account management workflow notes',
        pacing: 'Open pacing checks and delivery troubleshooting steps',
        person: 'Open people and staffing workflow references',
        projects: 'Open project lifecycle and ownership workflow steps',
        time: 'Open time entry and approvals workflow guidance',
      }

      return guideSubtitleByRoute[reportName] || 'Jump to route-specific help and workflow notes'
    },

    helpMenuSections() {
      const primaryItems = this.isInternalUser
        ? [
          {
            id: 'resume-tour',
            title: 'Resume Tour',
            subtitle: 'Continue from your last saved step on this page',
            icon: ['fas', 'clock-rotate-left'],
            emit: 'resume-tour',
            disabled: !this.canResumeTour,
          },
          {
            id: 'start-tour',
            title: 'Start Guided Tour',
            subtitle: 'Walk through core actions for this view (shortcut: T)',
            icon: ['fas', 'compass'],
            emit: 'start-tour',
            payload: 'help-menu',
            disabled: !this.showTourAction,
          },
          {
            id: 'page-guide',
            title: 'Open Page Guide',
            subtitle: this.pageGuideSubtitle,
            icon: ['fas', 'book-open'],
            to: this.pageHelpPath,
            disabled: !this.pageHelpPath,
          },
        ]
        : [
          {
            id: 'page-guide',
            title: 'Open Page Guide',
            subtitle: this.pageGuideSubtitle,
            icon: ['fas', 'book-open'],
            to: this.pageHelpPath,
            disabled: !this.pageHelpPath,
          },
          {
            id: 'docs-home',
            title: 'Browse Help Docs',
            subtitle: 'Open guides, feature references, and troubleshooting',
            icon: ['fas', 'folder-open'],
            to: '/docs/getting-started',
          },
        ]

      const supportItems = this.isInternalUser
        ? [
          {
            id: 'docs-home',
            title: 'Browse Help Docs',
            subtitle: 'Open guides, release notes, and reference pages',
            icon: ['fas', 'folder-open'],
            to: '/docs/getting-started',
          },
          {
            id: 'release-summary',
            title: 'See What Changed',
            subtitle: 'Review the current release summary and notable updates',
            icon: ['fas', 'file-alt'],
            to: '/docs/release-summary',
          },
          {
            id: 'shortcuts',
            title: 'Keyboard Shortcuts',
            subtitle: 'Open the shortcut reference for this view',
            icon: ['fas', 'keyboard'],
            emit: 'show-keyboard-shortcuts',
          },
          {
            id: 'feedback',
            title: 'Send Feedback',
            subtitle: 'Report issues or suggest improvements in-app',
            icon: ['fas', 'comment-dots'],
            dialog: 'feedback',
          },
          {
            id: 'clear-cache',
            title: 'Clear Cache & Data',
            subtitle: 'Purge cached files, storage, and service workers',
            icon: ['fas', 'trash-can'],
            dialog: 'clear-cache',
          },
        ]
        : [
          {
            id: 'release-summary',
            title: 'See What Changed',
            subtitle: 'Review current release highlights and updates',
            icon: ['fas', 'file-alt'],
            to: '/docs/release-summary',
          },
          {
            id: 'shortcuts',
            title: 'Keyboard Shortcuts',
            subtitle: 'Open the shortcut reference for this view',
            icon: ['fas', 'keyboard'],
            emit: 'show-keyboard-shortcuts',
          },
          {
            id: 'feedback',
            title: 'Send Feedback',
            subtitle: 'Report issues or suggest improvements in-app',
            icon: ['fas', 'comment-dots'],
            dialog: 'feedback',
          },
          {
            id: 'clear-cache',
            title: 'Clear Cache & Data',
            subtitle: 'Purge cached files, storage, and service workers',
            icon: ['fas', 'trash-can'],
            dialog: 'clear-cache',
          },
        ]

      const aboutItems = [
        {
          id: 'about',
          title: 'About iAdOps',
          subtitle: 'Version, environment, and current view',
          icon: ['fas', 'circle-info'],
          dialog: 'about',
        },
      ]

      return [
        {
          id: 'primary',
          title: this.isInternalUser ? 'Page Actions' : 'Help for This Page',
          items: primaryItems,
        },
        {
          id: 'support',
          title: this.isInternalUser ? 'Reference and Support' : 'More Help',
          items: supportItems,
        },
        {
          id: 'about',
          title: 'About',
          items: aboutItems,
        },
      ]
    },
  },
  watch: {
    inDemoMode() {
      this.$store.dispatch('tools/getDataRefresh')
    },
  },
  created() {
    this.$store.dispatch('tools/getDataRefresh')
  },
  methods: {
    showFeedbackMessage(message, status = 'info') {
      this.$store.commit('tools/snackbar', true)
      this.$store.commit('tools/snack', { message, status })
    },

    resetFeedbackForm() {
      this.feedbackForm = {
        category: 'general',
        summary: '',
        details: '',
      }
    },

    async submitFeedback() {
      if (this.isSubmittingFeedback) return

      const summary = this.feedbackForm.summary.trim()
      const details = this.feedbackForm.details.trim()

      if (!summary || summary.length < 3) {
        this.showFeedbackMessage('Please provide a short summary (at least 3 characters).', 'error')
        return
      }

      if (!details || details.length < 10) {
        this.showFeedbackMessage('Please provide details (at least 10 characters).', 'error')
        return
      }

      this.isSubmittingFeedback = true

      try {
        const response = await api.submitFeedback({
          category: this.feedbackForm.category,
          summary,
          details,
          context: {
            path: this.$route?.fullPath || '',
            reportKey: this.reportKey || '',
            routeName: this.$route?.name || '',
          },
        })

        if (response?.error) {
          throw response
        }

        if (this.$analytics) {
          this.$analytics.event('feedback_submit_success', {
            category: this.feedbackForm.category,
            reportKey: this.reportKey || 'unknown',
            routeName: this.$route?.name || 'unknown',
          })
        }

        this.showFeedbackMessage('Thanks. Your feedback was submitted successfully.', 'success')
        this.openFeedbackDialog = false
        this.resetFeedbackForm()
      } catch (error) {
        if (this.$analytics) {
          this.$analytics.event('feedback_submit_failure', {
            category: this.feedbackForm.category,
            message: error?.message || 'unknown',
            reportKey: this.reportKey || 'unknown',
            routeName: this.$route?.name || 'unknown',
          })
        }

        const message = error?.message || 'We could not submit feedback right now. Please try again.'
        this.showFeedbackMessage(message, 'error')
      } finally {
        this.isSubmittingFeedback = false
      }
    },

    toggleLegend() {
      this.$store.commit('delivery/isLegendModalVisible', !this.isLegendModalVisible)
    },
    hideLegendDataFreshness() {
      this.toggleDataFreshnessLegend = false
    },
    /**
     * Focus the search bar input field
     */
    focusSearch() {
      if (this.$refs.searchBar) {
        // SearchBar component has a v-text-field, find its input
        this.$nextTick(() => {
          const searchInput = this.$refs.searchBar.$el.querySelector('input')
          if (searchInput) {
            searchInput.focus()
          }
        })
      }
    },

    navigateTo(path) {
      this.openHelpMenu = false
      if (!path) return

      if (this.$route?.fullPath === path) {
        return
      }

      this.$router.push(path).catch(() => {})
    },

    handleHelpItemClick(item) {
      if (!item || item.disabled) return

      this.openHelpMenu = false

      let actionType = 'navigate'

      if (item.dialog) {
        actionType = 'dialog'
      } else if (item.emit) {
        actionType = 'emit'
      }

      fireanalytics.event('help_menu_action', {
        actionId: item.id || 'unknown',
        actionType,
        reportKey: this.reportKey || 'unknown',
        routeName: this.$route?.name || 'unknown',
      })

      if (item.dialog === 'feedback') {
        this.openFeedbackDialog = true
        return
      }

      if (item.dialog === 'clear-cache') {
        this.openClearCacheDialog = true
        return
      }

      if (item.dialog === 'about') {
        this.openAboutDialog = true
        return
      }

      if (item.emit) {
        this.$emit(item.emit, item.payload || 'help-menu')
        return
      }

      if (item.to) {
        this.navigateTo(item.to)
      }
    },

    async clearAppCache() {
      this.isClearingCache = true
      try {
        // Clear browser storage
        localStorage.clear()
        sessionStorage.clear()

        // Unregister service workers
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations()
          await Promise.all(registrations.map((reg) => reg.unregister()))
        }

        // Clear browser cache storage
        if ('caches' in window) {
          const cacheNames = await caches.keys()
          await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
        }

        // Fire analytics event
        fireanalytics.event('app_cache_cleared', {
          reportKey: this.reportKey || 'unknown',
          routeName: this.$route?.name || 'unknown',
          timestamp: new Date().toISOString(),
        })

        // Close dialog and show success message
        this.openClearCacheDialog = false
        this.$store.commit('tools/snack', {
          message: 'Cache cleared successfully. Reloading app...',
          status: 'success',
        })

        // Reload page after a short delay to allow snackbar to show
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      } catch (error) {
        this.isClearingCache = false
        this.$store.commit('tools/snack', {
          message: 'Error clearing cache. Please try again.',
          status: 'error',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.client-search {
  min-width: 120px;
  max-width: 320px;
}

.header-action {
  min-width: 52px;
}

.data-refresh-icon {
  max-width: 16px;
}

.data-refresh-text {
  min-width: fit-content;
}

.v-select.v-text-field input {
  max-width: 0 !important;
}

.create-item {
  min-width: 21px !important;
  padding: 0 !important;
}

.line-height-double {
  line-height: 2;
}

.help-menu-list {
  min-width: 272px;
  max-width: 308px;
}

.help-menu-list ::v-deep .v-subheader {
  letter-spacing: 0.04em;
  color: #4f6577;
  font-weight: 600;
}

.help-menu-list ::v-deep .v-list-item {
  border-left: 2px solid transparent;
  background-color: #ffffff;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.help-menu-list ::v-deep .v-list-item:hover {
  background-color: rgba(0, 125, 214, 0.1);
}

.help-menu-list ::v-deep .v-list-item .v-list-item__title {
  color: #0f2d43;
  font-weight: 600;
}

.help-menu-list ::v-deep .v-list-item__subtitle {
  line-height: 1.25;
  white-space: normal;
  color: #3f525f;
}

.help-menu-list ::v-deep .v-divider {
  border-color: rgba(15, 45, 67, 0.16);
}

.help-menu-list ::v-deep .v-simple-table {
  background-color: rgba(15, 45, 67, 0.03);
}

.help-menu-list ::v-deep .v-simple-table td {
  color: #17374e;
}

.help-menu-list ::v-deep .v-list-item.help-menu-item--tour {
  border-left-color: rgba(0, 125, 214, 0.35);
}

.help-menu-list ::v-deep .v-list-item.help-menu-item--tour .v-list-item__icon {
  color: #007dd6;
}

.theme--dark .help-menu-list ::v-deep .v-subheader {
  color: #a8c0d3;
}

.theme--dark .help-menu-list ::v-deep .v-list-item {
  background-color: #1b232b;
}

.theme--dark .help-menu-list ::v-deep .v-list-item:hover {
  background-color: rgba(138, 198, 255, 0.14);
}

.theme--dark .help-menu-list ::v-deep .v-list-item .v-list-item__title {
  color: #e6eef5;
}

.theme--dark .help-menu-list ::v-deep .v-list-item__subtitle {
  color: #c0d0dc;
}

.theme--dark .help-menu-list ::v-deep .v-divider {
  border-color: rgba(230, 238, 245, 0.18);
}

.theme--dark .help-menu-list ::v-deep .v-simple-table {
  background-color: rgba(230, 238, 245, 0.06);
}

.theme--dark .help-menu-list ::v-deep .v-simple-table td {
  color: #d5e2ec;
}

.help-dialog {
  border-radius: 14px;
}

.help-dialog__title-wrap {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.help-dialog__title-block {
  min-width: 0;
}

.help-dialog__title-row {
  align-items: center;
  color: #0b4f87;
  display: flex;
  font-size: 2rem;
  font-weight: 600;
  gap: 10px;
  line-height: 1.2;
}

.help-dialog__title-icon {
  color: #0d66ad;
  font-size: 0.95rem;
}

.help-dialog__title-text {
  color: #0b4f87;
  white-space: normal;
  word-break: break-word;
}

.help-dialog__subtitle {
  color: #516777;
  font-size: 0.9rem;
  line-height: 1.35;
  margin-top: 8px;
}

.help-dialog__close-btn {
  color: #788894;
  margin-top: -4px;
}

.help-dialog__section-label {
  color: #2f4658;
  font-size: 0.96rem;
  font-weight: 600;
}

.help-dialog__checklist {
  display: grid;
  gap: 9px;
}

.help-dialog__checklist-item {
  align-items: center;
  color: #304857;
  display: flex;
  font-size: 0.95rem;
  gap: 9px;
}

.help-dialog__check-icon {
  color: #1b7b5f;
  font-size: 0.84rem;
}

.help-dialog__note {
  align-items: flex-start;
  background: rgba(255, 165, 0, 0.12);
  border: 1px solid rgba(255, 165, 0, 0.3);
  border-radius: 10px;
  color: #5f4a20;
  display: flex;
  font-size: 0.89rem;
  gap: 8px;
  line-height: 1.35;
  padding: 11px 12px;
}

.help-dialog__note-icon {
  color: #c46b00;
  margin-top: 2px;
}

.about-metadata {
  border: 1px solid rgba(11, 79, 135, 0.12);
  border-radius: 10px;
  overflow: hidden;
}

.about-metadata__row {
  display: grid;
  gap: 12px;
  grid-template-columns: 130px 1fr;
  padding: 12px 14px;
}

.about-metadata__row + .about-metadata__row {
  border-top: 1px solid rgba(11, 79, 135, 0.12);
}

.about-metadata__label {
  color: #1e3343;
  font-size: 0.95rem;
  font-weight: 700;
}

.about-metadata__value {
  color: #2f4858;
  font-size: 0.95rem;
}

.about-metadata__value--mono {
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  font-size: 0.9rem;
  word-break: break-all;
}

.theme--dark .help-dialog__title-row,
.theme--dark .help-dialog__title-text,
.theme--dark .help-dialog__title-icon {
  color: #a7d7ff;
}

.theme--dark .help-dialog__subtitle {
  color: #c7d8e5;
}

.theme--dark .help-dialog__close-btn {
  color: #b9cad6;
}

.theme--dark .help-dialog__section-label,
.theme--dark .help-dialog__checklist-item,
.theme--dark .about-metadata__label,
.theme--dark .about-metadata__value {
  color: #d8e5ef;
}

.theme--dark .help-dialog__check-icon {
  color: #5fd0a5;
}

.theme--dark .help-dialog__note {
  background: rgba(255, 165, 0, 0.15);
  border-color: rgba(255, 165, 0, 0.35);
  color: #ffd9a3;
}

.theme--dark .help-dialog__note-icon {
  color: #ffbe63;
}

.theme--dark .about-metadata {
  border-color: rgba(167, 215, 255, 0.26);
}

.theme--dark .about-metadata__row + .about-metadata__row {
  border-top-color: rgba(167, 215, 255, 0.22);
}

@media (max-width: 600px) {
  .help-dialog__title-row {
    font-size: 1.75rem;
  }

  .about-metadata__row {
    gap: 6px;
    grid-template-columns: 1fr;
  }

  .about-metadata__label {
    font-size: 0.85rem;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
}

</style>
